import { TileWrapperProps } from './tileTypes';
import React from 'react';

export const LargeTileWrapper = ({ children, className = '' }: TileWrapperProps) => {
  return (
    <article className={`group relative flex flex-col h-full rounded-32 min-h-240 lg:min-h-288 ${className}`}
      data-tracking-meta-data={JSON.stringify({ tileType: 'Large' })}
    >
      {children}
    </article>
  );
};

export const MediumLargeTileWrapper = ({ children, className = '' }: TileWrapperProps) => {
  return (
    <article className={`relative w-full bg-white rounded-32 grid grid-rows-[152px_auto] gap-12 ${className}`}
      data-tracking-meta-data={JSON.stringify({ tileType: 'MediumLarge' })}
    >
      {children}
    </article>
  );
};

